var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _circle, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoHat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4558 27.807C15.3397 27.807 15.2215 27.7866 15.1065 27.7436C14.5895 27.5501 14.3261 26.9751 14.5196 26.4581L18.8933 14.7353C19.0857 14.2182 19.6619 13.9549 20.1789 14.1484C20.6959 14.3419 20.9593 14.9169 20.7658 15.434L16.3921 27.1567C16.2426 27.5588 15.8611 27.807 15.4558 27.807Z",
    fill: "#94959B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.63399 32.0899C6.26315 32.0899 5.90629 31.8824 5.7343 31.5266C5.49353 31.03 5.69991 30.4313 6.19758 30.1905L15.0214 25.9071C15.518 25.6652 16.1167 25.8738 16.3575 26.3693C16.5983 26.8659 16.3919 27.4635 15.8953 27.7054L7.07147 31.9888C6.92851 32.0576 6.78017 32.0899 6.63399 32.0899Z",
    fill: "#94959B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0447 32.5793C43.8523 32.5793 43.6577 32.5234 43.4858 32.4073L34.4341 26.2869C33.9773 25.9773 33.8569 25.356 34.1664 24.8992C34.476 24.4423 35.0973 24.322 35.5541 24.6315L44.6058 30.752C45.0626 31.0615 45.183 31.6828 44.8735 32.1397C44.681 32.4256 44.365 32.5793 44.0447 32.5793Z",
    fill: "#94959B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.994 26.4587C34.6049 26.4587 34.234 26.2297 34.0728 25.8481L29.6808 15.4733C29.4658 14.9648 29.7034 14.3779 30.2118 14.163C30.7202 13.948 31.3071 14.1855 31.5221 14.694L35.9141 25.0678C36.1291 25.5762 35.8915 26.1631 35.3831 26.3781C35.2563 26.4329 35.124 26.4587 34.994 26.4587Z",
    fill: "#94959B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6016 16.0841H19.8473C19.2948 16.0841 18.8477 15.637 18.8477 15.0845C18.8477 14.532 19.2948 14.0848 19.8473 14.0848H30.6016C31.1541 14.0848 31.6013 14.532 31.6013 15.0845C31.6013 15.637 31.1541 16.0841 30.6016 16.0841Z",
    fill: "#94959B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3434 27.2596L8.15137 30.6993C20.4091 37.7037 36.3983 33.6178 42.8607 30.6993L34.7306 25.6962L15.3434 27.2596Z",
    fill: "#94959B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9393 35.4318C25.9253 35.4318 25.9102 35.4318 25.8963 35.4318C19.2728 35.4264 12.6933 34.3107 6.34072 32.1157C5.8194 31.9351 5.54207 31.3665 5.72266 30.8441C5.90324 30.3217 6.47293 30.0455 6.99426 30.2261C13.1362 32.349 19.4963 33.4282 25.8984 33.4325C25.9124 33.4325 25.9264 33.4325 25.9403 33.4325C31.9597 33.4325 37.9555 32.4801 43.761 30.6023C44.2866 30.4324 44.8499 30.7205 45.0197 31.2461C45.1895 31.7718 44.9015 32.335 44.3758 32.5048C38.3704 34.4472 32.1683 35.4318 25.9393 35.4318Z",
    fill: "#94959B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4549 27.8065C14.9346 27.8065 14.495 27.4034 14.4584 26.8757C14.4208 26.3253 14.8357 25.847 15.3871 25.8094L34.9244 24.4604C35.4737 24.4217 35.952 24.8377 35.9907 25.3891C36.0283 25.9394 35.6134 26.4178 35.062 26.4554L15.5247 27.8044C15.5021 27.8054 15.4785 27.8065 15.4549 27.8065Z",
    fill: "#94959B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4794 23.5077C17.0186 23.5077 16.6293 23.1121 16.5969 22.5942C16.5627 22.0541 16.9311 21.5847 17.4184 21.5478L32.5338 20.3832C33.0222 20.3452 33.4448 20.7534 33.4781 21.2935C33.5124 21.8336 33.144 22.303 32.6566 22.34L17.5412 23.5045C17.5212 23.5066 17.5003 23.5077 17.4794 23.5077Z",
    fill: "#94959B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7789 22.257L19.7217 22.7614L19.9466 25.9081L27.0039 25.4036L26.7789 22.257Z",
    fill: "#94959B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2197 23.1944L20.034 15.377H30.353L32.5418 21.6309L17.2197 23.1944Z",
    fill: "#94959B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 24.999,
    r: 23.9437,
    stroke: "#E1625B",
    strokeWidth: 2.11268
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.6884 10.6219L9.8856 43.0163L8.42383 41.4909L42.2266 9.09656L43.6884 10.6219Z",
    fill: "#E1625B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoHat);
export default __webpack_public_path__ + "static/media/no-hat.e1fcd02eee1ae82598c01f3f85af7cb0.svg";
export { ForwardRef as ReactComponent };